module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/map@4x-3e4fc2fd374cb4a26e5263668ac27f48.png";